import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { forwardRef } from "react";

import { cn } from "../../lib/cn";
import { Button, type ButtonProps } from "../Button";

export interface NavigationContextButtonProps
  extends Omit<ButtonProps, "children"> {
  value: string;
}

/** A compact context selector for a navy navigation bar. */
export const NavigationContextButton = forwardRef<
  HTMLButtonElement,
  NavigationContextButtonProps
>(function NavigationContextButton({ value, className, ...props }, ref) {
  return (
    <Button
      ref={ref}
      type="button"
      variant="ghost"
      title={value}
      {...props}
      className={cn(
        "h-10 w-full min-w-0 justify-between gap-3 border border-on-navy/20 bg-navy-strong/40 px-3 text-on-navy hover:border-on-navy/40 hover:bg-navy-strong focus-visible:ring-highlight focus-visible:ring-offset-navy",
        className,
      )}
    >
      <span className="min-w-0 truncate text-left text-sm font-semibold">
        {value}
      </span>
      <ChevronDownIcon
        className="size-4 shrink-0 text-on-navy/70"
        aria-hidden="true"
      />
    </Button>
  );
});
